<h2 mat-dialog-title>{{ action === 'edit' ? 'Edit' : 'Create' }} Approach Profile</h2>
<mat-dialog-content class="mat-typography">
  <div class="container">
    <app-form-builder [formFields]="formFields" [(formGroup)]="userForm"></app-form-builder>
    <!-- {{ userForm.value | json }} -->
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!userForm.valid || submitting">
    {{ submitting ? 'Submitting...' : 'Submit' }}
  </button>
</mat-dialog-actions>
